import { createStorageAtomFactory } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

const createTestnetsEnabledAtom = ({ storage }) =>
  createStorageAtomFactory<boolean | null>({ storage })({
    key: 'enabled',
    defaultValue: null,
  });

export const testnetsEnabledAtomDefinition = {
  id: 'testnetsEnabledAtom',
  type: 'atom',
  factory: createTestnetsEnabledAtom,
  dependencies: ['storage'],
} as const satisfies Definition;

export type TestnetsEnabledAtom = ReturnType<typeof createTestnetsEnabledAtom>;
